import type { GraphQLError } from "graphql/error/GraphQLError";

export type GqlError = {
	client: string;
	operationName?: string;
	operationType?: string;
	statusCode?: number;
	gqlErrors: GraphQLError[];
};

interface ConnectivityError {
	id: number;
	time: Date;
	error: GqlError;
}

let errorId = 0;

export const useConnectivityStore = defineStore("connectivity", () => {
	useGqlError((err: GqlError) => {
		console.error("GqlError", err);

		if (err.statusCode === 401)
			needsReconnect.value = true;

		addRequestError(err);
	});

	console.log("useConnectivityStore -- init");

	const needsReconnect = ref(false);

	const requestErrors = ref<ConnectivityError[]>([]);	// requestErrors

	const lastError = computed(() => requestErrors.value[requestErrors.value.length - 1]);

	const hasErrors = computed(() => !!lastError.value);

	const needsAuthentication = computed(() => lastError.value?.error.statusCode === 401);

	const refreshCookies = async () => {
		console.log("refreshCookies -- start");

		try {
			const response = await GqlGetCurrentUser();

			console.log("GqlGetCurrentUser response: ", response);
		}
		catch (e: any) {
			console.error("GqlGetCurrentUser error: ", e);
			needsReconnect.value = true;
		}
		finally {
			console.log("refreshCookies -- end");
		}
	};

	// // add timer to check if needsReconnect
	// setInterval(() => {
	// 	needsReconnect.value = true;
	// }, 1000 * 60 * 1);	// 3 minutes

	function addRequestError(error: GqlError | ConnectivityError) {
		if ("error" in error) {
			error.time = new Date();
			error.id = errorId++;
			requestErrors.value.push(error);
		}
		else {
			requestErrors.value.push({
				id: errorId++,
				time: new Date(),
				error,
			});
		}
	}

	return {
		hasErrors,
		lastError,
		requestErrors,
		needsReconnect,
		needsAuthentication,
		refreshCookies,
	};
},
);
